import { defineComponent as _defineComponent } from 'vue'

import type { SortSelectedItem, CompareSortSelection, SortDropdownAlign } from '@/types/report-sort';
import { SORT_DROPDOWN_ALIGN, SORT_TYPE } from '@/types/report-sort';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownSortList',
  props: {
    column: null,
    selected: null,
    align: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({ (e: 'select', data: SortSelectedItem): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    column: string;
    selected?: CompareSortSelection | null;
    align?: SortDropdownAlign;
}




const SORT_LIST = [
    { name: 'Без сортировки', icon: 'mdi-arrow-up-down', direction: null, sortType: SORT_TYPE.None },
    { name: 'По текущему значению', icon: 'mdi-arrow-down', direction: 'desc', sortType: SORT_TYPE.Current },
    { name: 'По текущему значению', icon: 'mdi-arrow-up', direction: 'asc', sortType: SORT_TYPE.Current },
    { name: 'По предыдущему значению', icon: 'mdi-arrow-down', direction: 'desc', sortType: SORT_TYPE.Prev },
    { name: 'По предыдущему значению', icon: 'mdi-arrow-up', direction: 'asc', sortType: SORT_TYPE.Prev },
    { name: 'По разнице', icon: 'mdi-arrow-down', direction: 'desc', sortType: SORT_TYPE.Diff },
    { name: 'По разнице', icon: 'mdi-arrow-up', direction: 'asc', sortType: SORT_TYPE.Diff },
];

function isItemActive(item: (typeof SORT_LIST)[number]): boolean {
    const sel = props.selected;
    if (!sel || sel.sortType === SORT_TYPE.None) return false;
    return sel.sortType === item.sortType && sel.direction === item.direction;
}

const handleUpdate = (item: typeof SORT_LIST[number]) => {
    emit('select', {
        column: props.column,
        sortType: item.sortType,
        direction: item.direction,
    });
};

return { __sfc: true,props, emit, SORT_LIST, isItemActive, handleUpdate, SORT_DROPDOWN_ALIGN }
}

})